import guard from 'scoreboard/components/unsaved/guard'

/**
 * Handles drilldown behavior for dataset-based widgets
 * Prevents drilldown when form is dirty and handles 
 * dataset-specific drilldown logic
 */
function datasetWidgetDrilldown() {
	if (this.widgetEmptyState) {
		return
	}

	const d = this.model.drilldown()
	if (d.section === 'datasets' && d.request) {
		// #60170 add guard to prevent drilldown when form is dirty
		guard.conditionallyRun(() => {
			// For the "default" dataset drilldown, we need to pass along
			// filters, aggregationType, etc, so we can't use the default
			// widget drilldown logic.
			this.trigger('drilldown:value', d)
		})
	} else {
		// Call the parent view's drilldown method if it exists
		if (this.constructor.__super__.drilldown) {
			this.constructor.__super__.drilldown.apply(this, arguments)
		}
	}
}

export default datasetWidgetDrilldown
datasetWidgetDrilldown.__filename__ = 'dashboards/widgets/dataset-widget-drilldown.js'
